module.exports = __webpack_public_path__ + "static/media/affiliate-banner-fr.3b43e59e.png";